import React from 'react'

export const useLockBodyScroll = (enabled?: boolean) => {
  const id = React.useId()

  React.useEffect(() => {
    if (typeof window === 'undefined' || !enabled) return

    // Inject stylesheet
    const style = document.createElement('style')
    style.setAttribute('data-id', id)
    style.setAttribute('data-scroll-top', `${window.scrollY}`)
    style.innerHTML = `
      body {
        overflow: hidden;
      }
    `
    document.head.appendChild(style)

    return () => {
      if (typeof window === 'undefined') return

      const style = document.querySelector(`style[data-id="${id}"]`)
      if (!style) return

      // Get former scroll position
      const scrollY = style.getAttribute('data-scroll-top')

      // Remove stylesheet
      style.remove()

      // Restore scroll position
      window.scrollTo(0, parseInt(scrollY || '0'))
    }
  }, [enabled, id])
}
